import Vue from 'vue'
import { store } from './store'
import App from './App.vue'
import ClickOutside from 'vue-click-outside'
import PortalVue from 'portal-vue'
import VCalendar from 'v-calendar'
import router from './router'
import { configure } from 'vee-validate'
import webSocketService from './plugins/webSocketService'
import { i18n } from '@/plugins/vue-i18n/vue-i18n.js'
import './plugins/vue-toastification.js'
import './plugins/floating-vue.js'
import './rules/vee-validate-rules.js'
import './assets/scss/main.scss'
import 'floating-vue/dist/style.css'
import './assets/scss/plugins/floating-vue.scss'


configure({
  skipOptional: false
})

Vue.use(webSocketService, {
  store,
  url: process.env.VUE_APP_WS_URL
})

Vue.config.productionTip = false
Vue.use(PortalVue)
Vue.use(VCalendar)

Vue.directive('click-outside', ClickOutside)

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
